<template>
  <div class="b-breadcrumb-page">
    <div class="b-container">
      <div class="b-main">
        <div class="b-readcumb">
          <div class="b-coin"></div>
          <div class="b-home">当前位置：</div>
          <div class="b-cursor">
            <ul>
              <li>
                <router-link to="/">首页</router-link>
              </li>
              <li>
                <router-link :to="path">{{name}}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import $ from "jquery";

export default {
  data () {
    return {
      path: "",
      name: ""
    };
  },
  mounted () {
    this.path = this.$route;

    var map = {};
    map['about'] = "关于我们 > 设施简介";
    map['aboutEn'] = "Overview";
    map['about2'] = "关于我们 > 领导团队";
    map['about6'] = "关于我们 > 科研设施";
    map['about3'] = "关于我们 > 技术系统";
    map['about5'] = "关于我们 > 组织架构";
    map['about8'] = "关于我们 > 研究院简介";

    if(this.$route.query.type == 'sskxj' ) {
      map['talent'] = '人才队伍 > 设施科学家';
    }else if(this.$route.query.type == 'jszxzr'){
      map['talent'] = '人才队伍 > 技术中心主任';
    }else if(this.$route.query.type == 'sskxjzl' ) {
      map['talent'] = '人才队伍 > 设施科学家助理';
    }else if(this.$route.query.type == 'sysoffice' ) {
      map['talent'] = '人才队伍 > 管理队伍 > 实验室与技术平台办公室';
    }else if(this.$route.query.type == 'kxyjoffice' ) {
      map['talent'] = '人才队伍 > 管理队伍 > 科学研究办公室';
    }else if(this.$route.query.type == 'rlzyoffice' ) {
      map['talent'] = '人才队伍 > 管理队伍 > 人力资源办公室、学生培养办公室';
    }else if(this.$route.query.type == 'zhoffice' ) {
      map['talent'] = '人才队伍 > 管理队伍 > 综合办公室';
    }else if(this.$route.query.type == 'dwoffice' ) {
      map['talent'] = '人才队伍 > 管理队伍 > 对外合作办公室';
    }
    map['talentDetail'] = '人才队伍 > 正文';

    // map['service6'] = "科研服务 > 分析测试 > 公共仪器平台 > 光谱波谱质谱平台";
    // map['service7'] = "科研服务 > 分析测试 > 公共仪器平台 > 新药研发与工艺安全性评价平台";
    // map['service8'] = "科研服务 > 分析测试 > 公共仪器平台 > 电镜 - 影像中心(平台)";
    // map['service9'] = "科研服务 > 分析测试 > 公共仪器平台 > 上海交通大学校级计算平台";
    // map['service10'] = "科研服务 > 分析测试 > 公共仪器平台 > 诊疗仪器开发平台";

    map['service6'] = "科研服务 > 分析测试 > 公共仪器平台 > 冷冻电镜中心";
    map['service7'] = "科研服务 > 分析测试 > 公共仪器平台 > 表面与性能分析平台";
    map['service8'] = "科研服务 > 分析测试 > 公共仪器平台 > 元素分析平台";
    map['service9'] = "科研服务 > 分析测试 > 公共仪器平台 > 光谱、波谱、质谱平台";
    map['service10'] = "科研服务 > 分析测试 > 公共仪器平台 > 实验动物中心";
/*    map['service101'] = "科研服务 > 分析测试 > 公共仪器平台 > 诊疗装备开发服务平台";
    map['service102'] = "科研服务 > 分析测试 > 公共仪器平台 > 上海交通大学校级计算平台";
    map['service103'] = "科研服务 > 分析测试 > 公共仪器平台 > 高通量药物筛选平台";
    map['service104'] = "科研服务 > 分析测试 > 公共仪器平台 > 高通量测序平台";
    map['service105'] = "科研服务 > 分析测试 > 公共仪器平台 > 质谱检测平台";
    map['service106'] = "科研服务 > 分析测试 > 公共仪器平台 > 生物治疗研发平台";
    map['service107'] = "科研服务 > 分析测试 > 公共仪器平台 > 生信大数据平台";*/
    map['service14'] = "科研服务 > 分析测试 > 公共仪器平台 > 生物标记物与新药研发平台";
    map['service15'] = "科研服务 > 分析测试 > 公共仪器平台 > 诊断试剂开发平台";
    map['service16'] = "科研服务 > 分析测试 > 公共仪器平台 > 电镜 - 影像中心(平台)";


    if(this.$route.query.cat == 'pt')
      map['service0'] = "科研服务 > 分析测试 > 公共仪器平台";
    else if(this.$route.query.cat == 'zx')
      map['service0'] = "科研服务 > 技术合作";
    map['service2'] = "科研服务 > 技术合作 > 生物医学数据技术中心";
    map['service3'] = "科研服务 > 技术合作 > 模式动物技术中心";
    map['service'] = "科研服务 > 技术合作 > 新药创制技术中心";
    map['service4'] = "科研服务 > 技术合作 > 生物医学影像技术中心";
    map['service13'] = "科研服务 > 技术合作 > 临床验证技术中心";
/*    map['service108'] = "科研服务 > 技术合作 > 创新医疗器械注册研究及临床转化服务中心";
    map['service109'] = "科研服务 > 技术合作 > 运动转化医学中心";
    map['service110'] = "科研服务 > 技术合作 > 代谢病组学解析技术中心";*/

    map['service11'] = "科研服务 > 用户实验室";
    map['service12'] = "科研服务 > 会议服务";

    map['kyuser2'] = "用户管理 > 用户指南";
    map['kyuser1'] = "用户管理 > 用户入驻";
    map['kyuser3'] = "用户管理 > 在站科研用户";

    map['activity'] = "合作交流 > 联合研究中心";
    map['imageset'] = "合作交流 > 合作伙伴";
    map['cooperations'] = "合作交流 > 合作动态";
    map['tang'] = "合作交流 > 唐仲英楼";

    map['event2'] = "科学研究计划 > 开放研究计划";
    map['event1'] = "科学研究计划 > STAR计划";
    map['honor_system'] = "科学研究计划 > 唐仲英荣誉体系";
    map['health'] = "科学研究计划 > 上海交通大学大健康计划";

    map['party'] = "学习专栏 > 党建工作";
    map['party1'] = "学习专栏 > 主题教育";
    map['party2'] = "学习专栏 > 特色活动";

    map['rules'] = "服务指南 > 规章制度";

    map['pts'] = "公共仪器平台";
    map['zxs'] = "技术服务";
    map['yale'] = "合作交流 > 耶鲁中心";

    map['news'] = "新闻";
    if(this.$route.query.t == null || this.$route.query.t == '' )
      map['notice'] = "公告";
    else
      map['notice'] = "人才引进 > 招聘公告";

    map['sciences'] = "科学普及";

    if(this.$route.query.type == 'news')
      map['detail'] = "新闻 > 正文";
    else if(this.$route.query.type == 'notice' && this.$route.query.noticeType == 'home_notice')
      map['detail'] = "公告 > 正文";
    else if(this.$route.query.type == 'notice' && this.$route.query.noticeType == 'recruit_notice')
      map['detail'] = "人才引进 > 招聘公告 > 正文";
    else if(this.$route.query.type=='cooperations')
      map['detail'] = "合作交流 > 合作动态 > 正文";
    else if(this.$route.query.type=='topics')
      map['detail'] = "学习专栏 > 主题教育 > 正文";
    else if(this.$route.query.type=='activitys')
      map['detail'] = "学习专栏 > 特色活动 > 正文";
    else if(this.$route.query.type=='achievements') {
      if(this.$route.query.year=='10')
        map['detail'] = "科研成果 > 正文";
      else
        map['detail'] = "技术突破 > 正文";
    }
    else if(this.$route.query.type=='sciences')
      map['detail'] = "科学普及 > 正文";
    else if(this.$route.query.type=='rules')
      map['detail'] = "服务指南 > 规章制度 > 正文";
    else
      map['detail'] = "正文";

    map['achievements'] = "技术突破";
    map['achievements10'] = "科研成果";

    if(this.$route.query.id=='pt')
      map['kyuser'] = "公共仪器平台";
    else if(this.$route.query.id=='zx')
      map['kyuser'] = "技术合作";

    this.name = map[this.$route.name];
    console.log(this.name);

  }
};
</script>
<style lang="scss" scoped>
.b-breadcrumb-page {
  border-bottom: 1px solid #ddd;
  .b-readcumb {
    height: 50px;
    line-height: 45px;
    display: flex;
    align-items: center;
    .b-coin {
      width: 15px;
      height: 15px;
      background: url(../../assets/img/home.png) no-repeat;
      background-size: inherit;
      margin-right: 5px;
      margin-top: 3px;
    }
    .b-home {
      color: #777;
      font-size: 12px;
      font-weight: normal;
      font-family: Avenir, Helvetica, Arial, sans-serif;
      text-decoration: none;
    }
    .b-cursor ul {
      display: flex;
      align-items: center;
      li a {
        color: #777;
        font-size: 12px;
        font-weight: normal;
        font-family: microsoft yahei;
        text-decoration: none;
      }
      > li + li:before {
        content: ">";
        font-family: 宋体;
        color: #555;
        padding: 0 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb/index.vue